import React from 'react';

const Route: React.FunctionComponent = () => {
  return null;
};

export default Route;
